import { DeviceShadowDTO } from '@eppendorf/vnls-device-service-utils';
import type { HasClassName } from '@eppendorf/vnls-react-components';
import type { ReactElement } from 'react';

import { DoorOrLidStatus } from '$components/door-or-lid-status/door-or-lid-status';

export interface DoorOrLidStatusWrapperProps extends HasClassName {
  shadow?: DeviceShadowDTO;
  fallback?: string;
}

export function DoorOrLidStatusWrapper({
  shadow,
  fallback,
  className,
}: DoorOrLidStatusWrapperProps): ReactElement {
  if (shadow) {
    const doorOrLidSubject: 'door' | 'lid' = shadow.lidState ? 'lid' : 'door';

    const doorOrLidState =
      doorOrLidSubject === 'lid' ? shadow.lidState : shadow.doorState;

    return (
      <DoorOrLidStatus
        className={className}
        state={doorOrLidState ?? undefined}
        subject={doorOrLidSubject}
        fallback={fallback}
      />
    );
  }

  return <div />;
}
